import { getScrollbarWidth } from "@perxis-auto/shared";
import { createMediaPath } from "../../media/createMediaPath.js";
import { MediaTemplateEnum } from "../../../types/media.js";
import { formatVehicleTitle } from "./formatVehicleTitle.js";
const IMAGE_SIZE = {
  preview: [160, 120],
  xxs: [320, 240],
  xs: [480, 360],
  sm: [640, 480],
  md: [960, 720],
  lg: [1800, 1350]
};
const getImageSizes = (view) => {
  const scrollbarWidth = getScrollbarWidth();
  const sizes = [];
  if (view === "card") {
    sizes.push(
      // Ширина картинки занимает ширину экрана без scrollbar минус левые и правые отступы от контейнера.
      `(max-width: 575px) calc((100vw - ${scrollbarWidth}px) - var(--perxis-auto-container-padding-xxs-inner) * 2)`
    );
    sizes.push(
      // Ширина картинки занимает ширину экрана без scrollbar минус левые и правые отступы от контейнера.
      `(max-width: 991px) calc((100vw - ${scrollbarWidth}px) - var(--perxis-auto-container-padding-sm-inner) * 2)`
    );
    sizes.push(
      // Ширина картинки занимает 14 колонок от ширины экрана без scrollbar минус левые и правые отступы от контейнера.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: 1199px) calc((((100vw - ${scrollbarWidth}px) - var(--perxis-auto-container-padding-lg-inner) * 2 + 16px * 2) * 58.333333333333336 / 100) - 16px * 2)`
    );
    sizes.push(
      // Медиа-запрос покрывает отрезок между xl и максимальной шириной контейнера с учетом горизонтальных отступов.
      // Ширина картинки занимает 14 колонок от ширины экрана без scrollbar минус левые и правые отступы от контейнера.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: calc(var(--perxis-auto-container-max-width-inner) + var(--perxis-auto-container-padding-lg-inner) * 2)) calc((((100vw - ${scrollbarWidth}px) - var(--perxis-auto-container-padding-xl-inner) * 2 + 18px * 2) * 58.333333333333336 / 100) - 18px * 2)`
    );
    sizes.push(
      // Ширина картинки занимает 14 колонок от максимальной шириной контейнера.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `calc(((var(--perxis-auto-container-max-width-inner) + 18px * 2) * 58.333333333333336 / 100) - 18px * 2)`
    );
  }
  if (view === "tile") {
    sizes.push(
      // Ширина картинки занимает ширину экрана без scrollbar минус левые и правые отступы от списка с авто.
      `(max-width: 575px) calc((100vw - ${scrollbarWidth}px) - 20px - 20px)`
    );
    sizes.push(
      // Ширина картинки занимает 12 колонок от ширины экрана без scrollbar минус левые и правые отступы от списка с авто.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: 767px) calc((((100vw - ${scrollbarWidth}px) - 20px - 20px + 9px * 2) * 50 / 100) - 9px * 2)`
    );
    sizes.push(
      // Ширина картинки занимает 12 колонок от ширины экрана без scrollbar минус левые и правые отступы от списка с авто.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: 991px) calc(((100vw - ${scrollbarWidth}px) * 50 / 100) - 20px - 20px)`
    );
    sizes.push(
      // Ширина картинки занимает 16 колонок от ширины экрана без scrollbar минус левые и правые отступы от списка с авто, от рассчитанной ширины 12 колонок.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: 1199px) calc(((((100vw - ${scrollbarWidth}px) * 66.66666666666666 / 100) - 20px - 20px + 9px * 2) * 50 / 100) - 9px * 2)`
    );
    sizes.push(
      // Ширина картинки занимает 18 колонок от ширины экрана без scrollbar минус левые и правые отступы от списка с авто, от рассчитанной ширины 8 колонок.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `(max-width: 1599px) calc(((((100vw - ${scrollbarWidth}px) * 75 / 100) - 20px - 20px + 9px * 2) * 33.33333333333333 / 100) - 9px * 2)`
    );
    sizes.push(
      // Ширина картинки занимает 19 колонок от ширины экрана без scrollbar минус левые и правые отступы от списка с авто, от рассчитанной ширины 6 колонок.
      // В расчетах участвует горизонтальный gutter для правильного расчета ширины колонки, так как ширина Row учитывает отрицательный внешний отступ.
      `calc(((((100vw - ${scrollbarWidth}px) * 79.16666666666666 / 100) - 20px - 20px + 9px * 2) * 25 / 100) - 9px * 2)`
    );
  }
  return sizes;
};
const transformMedia = (extItem, options, template) => {
  const title = formatVehicleTitle(extItem);
  const { media: mediaImages = [] } = extItem.data;
  const { view, media } = options;
  const originalParams = {
    width: template === MediaTemplateEnum.Crop ? IMAGE_SIZE.sm[0] : IMAGE_SIZE.md[0],
    height: template === MediaTemplateEnum.Crop ? IMAGE_SIZE.sm[1] : IMAGE_SIZE.md[1]
  };
  const preparedImages = mediaImages.reduce((acc, image) => {
    if (!image || !image.file) {
      return acc;
    }
    const { id } = image.file;
    const original = createMediaPath(id, media, template, originalParams);
    const thumbnail = createMediaPath(id, media, template, {
      width: IMAGE_SIZE.preview[0],
      height: IMAGE_SIZE.preview[1]
    });
    const imageData = {
      title,
      original,
      thumbnail
    };
    switch (template) {
      case MediaTemplateEnum.Crop: {
        const sizes = getImageSizes(view);
        const srcSetSizes = [
          IMAGE_SIZE.xxs,
          IMAGE_SIZE.xs,
          IMAGE_SIZE.sm,
          ...view === "tile" ? [IMAGE_SIZE.md, IMAGE_SIZE.lg] : []
        ];
        const srcSet = srcSetSizes.map(([width, height]) => {
          return `${createMediaPath(id, media, template, { width, height })} ${width}w`;
        });
        if (sizes.length) {
          imageData.sizes = sizes.join(",");
        }
        if (srcSet.length) {
          imageData.srcSet = srcSet.join(",");
        }
        break;
      }
    }
    return [...acc, imageData];
  }, []);
  return preparedImages;
};
const formatVehicleImages = (extItem, options, template = MediaTemplateEnum.Crop) => {
  return transformMedia(extItem, options, template);
};
export {
  formatVehicleImages,
  getImageSizes
};
